<template>
  <div>
    <EditProductSidebar
      :isSidebarActive="openEditProductSidebar"
      @closeSidebar="toggleEditProductSidebar"
      :editProductData="editProductData"
      @getAllProduct="getAllProduct"
    />
    <modal :show.sync="editModal" header-classes="bg-primary p-3" size="lg">
      <h6
        slot="header"
        class="modal-title text-white modal-close-btn font-semibold pt-1"
      >
        ADD IMAGE
      </h6>
      <AddPageDetail />
      <template slot="footer">
        <base-button type="primary">SUBMIT</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>

    <!-- addproductdetails -->
    <modal
      :show.sync="ShowProductDetails"
      header-classes="bg-primary p-3"
      size="lg"
    >
      <h6
        slot="header"
        class="modal-title text-white modal-close-btn font-semibold pt-1"
      >
        ADD PRODUCT DETAILS
      </h6>
      <AddProductDetails />
      <template slot="footer">
        <base-button type="primary" class="hover:text-black"
          >SUBMIT</base-button
        >
        <base-button
          type="secondary"
          class="ml-auto"
          @click="ShowProductDetails = false"
          >CLOSE</base-button
        >
      </template>
    </modal>

    <!--Edit Product -->
    <modal
      :show.sync="ShowEditProduct"
      header-classes="bg-primary p-3"
      size="lg"
    >
      <h6
        slot="header"
        class="modal-title text-white modal-close-btn font-semibold pt-1"
      >
        EDIT
      </h6>
      <!-- <EditProduct /> -->
      <template slot="footer">
        <base-button type="primary">SUBMIT</base-button>
        <base-button
          type="secondary"
          class="ml-auto"
          @click="ShowEditProduct = false"
          >CLOSE</base-button
        >
      </template>
    </modal>

    <b-card class="rounded-2xl mb-4 cust-shadow cardbody-p">
      <div class="row">
        <div  class="col-sm-3">
          <img
          v-if="item.productImage"
            :src="`${$imageURL}/${item.productImage}`"
            class="rounded-lg"
            :alt="item.name"
          />
          <img
          v-else
            :src="$noIMG"
            class="rounded-lg"
            :alt="item.name"
          />
        </div>

        <div class="col-sm-6 py-2 pl-2">
          <div>
            <p class="font-bold">{{ item.name }}</p>
            <!-- <small class="text-muted ellipsis-3">{{ item.description }}</small> -->
            <small class="text-muted ellipsis-3"
              ><b>{{
                item.brandData.length ? item.brandData[0].name : item.brand
              }}</b></small
            >
          </div>
          <div class="mt-4">
            <div class="color">
              <p class="font-semibold text-md rounded-full">
                Price:
                <span class="ml-2 text-base font-semibold"
                  >&#8377; {{ item.price }}</span
                >
              </p>
            </div>
            <div class="color" v-if="item.discount">
              <p class="font-semibold text-md rounded-full">
                Discount:
                <span class="ml-2 text-base font-semibold"
                  >{{ item.discount }}%</span
                >
              </p>
            </div>
            <div class="color" v-if="item.couponCode">
              <p class="font-semibold text-md rounded-full">
                Coupon Code:
                <span class="ml-2 text-base font-semibold">{{
                  item.couponCode
                }}</span>
              </p>
            </div>
            <div class="color" v-if="item.hasOwnProperty('isURL')">
              <p class="font-semibold text-md rounded-full" v-if="item.isURL">
                URL:
                <span class="ml-2 text-base font-semibold">{{ item.url }}</span>
              </p>
              <p class="font-semibold text-md rounded-full" v-else>
                SKU:
                <span class="ml-2 text-base font-semibold">{{ item.sku }}</span>
              </p>
            </div>
            <div class="color" v-else>
              <p class="font-semibold text-md rounded-full">
                URL:
                <span class="ml-2 text-base font-semibold">{{ item.url }}</span>
              </p>
            </div>
          </div>

          <!-- <div class="w-1/4 mr-4">
              <label
                class=" col-form-label form-control-label  text-base font-semibold text-black"
                >Size
              </label>
              <base-input class="">
                <select class="form-control ">
                  <option> Select </option>
                  <option> 1 </option>

                  <option> 2 </option>
                  <option> 3 </option>
                  <option> 4 </option>
                </select>
              </base-input>
            </div>

            <div class="w-1/4 ">
              <label
                class=" col-form-label form-control-label  text-base font-semibold text-black"
                >Diamond
              </label>
              <base-input class="">
                <select class="form-control ">
                  <option> Select </option>
                  <option>IJS1 </option>

                  <option> IJS2 </option>
                </select>
              </base-input>
            </div>
          </div> -->

          <!-- <div class="size mt-6">
            <p class="font-semibold text-md rounded-full">
              Select Size
            </p>
            <div class="flex mt-4 justify-between items-center">
              <div class="flex">
                <div
                  class="border cursor-pointer rounded-full text-center border-primary-hover mr-3 py-2  w-20 0"
                  v-for="(item, index) in sizeOptions"
                  :key="'item-' + index"
                  @click="handleSize(item)"
                  :class="{ 'border-primary': item === selectedSize }"
                >
                  <p
                    class="font-semibold text-xs"
                    :class="{ 'text-primary': item === selectedSize }"
                  >
                    {{ item.size }}<br />
                    <small
                      class=" fsize11"
                      :class="{ 'text-primary': item === selectedSize }"
                      >Rs. {{ item.price }}</small
                    >
                  </p>
                </div>
              </div>

              
            </div>
          </div> -->
          <!-- <div class="mt-4">
            <p class="text-base font-semibold">
              URL:
              <span class="text-base font-semibold ml-2">24999</span>
            </p>
          </div> -->
        </div>

        <div class="col-sm-3 flex items-center">
          <div class="pr-4">
            <!-- <base-button
              outline
              type="light"
              @click="editModal = true"
              class="mb-2 w-full py-2 text-xs hover:text-white"
            >
              Add Images
            </base-button>
            <base-button
              type="success"
              @click="ShowProductDetails = true"
              class="mb-2 w-full py-2 text-xs hover:bg-white hover:text-black hover:border-primary hover:border-2"
            >
              Add Product Details
            </base-button>
            <base-button
              outline
              type="light"
              class="mb-2 w-full py-2 text-xs hover:text-white"
              @click="editModal = true"
            >
              Edit Images
            </base-button> -->
            <base-button
              outline
              type="primary"
              class="mb-2 w-full py-2 text-xs hover:text-white"
              @click="editProduct(item)"
            >
              Edit
            </base-button>
            <base-button
              type="danger"
              @click="handleDelete(item)"
              outline
              class="mb-2 w-full py-2 text-xs"
            >
              Delete
            </base-button>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import AddPageDetail from "./AddPageDetail";
import AddProductDetails from "./AddProductDetails";

import EditProductSidebar from "./EditProductSidebar.vue";
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    AddPageDetail,
    AddProductDetails,

    EditProductSidebar,
  },
  data() {
    return {
      openEditProductSidebar: false,

      selectedItem: 1,
      selectedSize: null,
      editModal: false,
      ShowProductDetails: false,
      ShowEditProduct: false,
      editProductData: {},
    };
  },

  methods: {
    handleClick(item) {
      this.selectedItem = item;
    },
    getAllProduct() {
      this.$emit("getAllProduct");
    },

    editProduct(item) {
      this.toggleEditProductSidebar(true);
      this.editProductData = item;
    },
    toggleEditProductSidebar(val = false) {
      this.openEditProductSidebar = val;
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },

    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData(row) {
      let loader;
      let payload = {
        productId: row._id,
      };
      loader = this.$loading();
      try {
        const data = await this.$store.dispatch(
          "affiliate/deleteProduct",
          payload
        );
        loader.close();
        if (data.code === 200) {
          this.getAllProduct();
          await this.$swal({
            text: "Product successfully removed",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
        }
      } catch (err) {
        console.log(err);
        loader.close();
      }
    },
  },
};
</script>

<style scoped>
.active-color {
  border: 1px solid black;
}
.form-group {
  margin-bottom: 0 !important;
}
</style>
